import * as React from "react";

export default function Spinner({ className }: { className?: string }) {
  return (
    <svg
      className={`svg-spinner ${className}`}
      viewBox="25 25 50 50"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle className="circle-spinner" r="20" cx="50" cy="50" />
    </svg>
  );
}
